import { Module } from '@nestjs/common';
import { ForkLiftItemsService } from './fork-lift-items.service';
import { ForkLiftItemsController } from './fork-lift-items.controller';

@Module({
  providers: [ForkLiftItemsService],
  controllers: [ForkLiftItemsController]
})
export class ForkLiftItemsModule {}
